import React from "react";
import Box from "@material-ui/core/Box";
import makeStyles from "@material-ui/styles/makeStyles";
import CmtImage from "src/@coremat/CmtImage";
import { useSelector } from "react-redux";
// const bgImage = "/images/auth/auth-bg-pattern.png";

const useStyles = makeStyles((theme) => ({
	authWrap: {
		width: "100vw",
		height: "100vh",
		minHeight: "100vh",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		background: "#fff",
		padding: 0,
		overflow: "auto",
	},
	authCard: {
		position: "relative",
		zIndex: 3,
		maxWidth: 600,
		width: "100%",
		margin: 0,
		color: theme.palette.text.secondary,
		display: "flex",
		flexDirection: "column",
		padding: 48,
	},
	authContent: {
		width: "100%",
		padding: 0,
		marginTop: 24,
	},
	logo: {
		width: "15vw",
		margin: "0 auto 32px auto",
		display: "block",
	},
}));

const AuthWrapper = ({ children, variant, screen }) => {
	const classes = useStyles({ variant, screen });
	const { tenant } = useSelector(({ auth }) => auth);
	return (
		<Box className={classes.authWrap + " bg-white min-h-screen w-screen flex items-center justify-center"}>
			<Box className={classes.authCard + " w-full flex flex-col"}>
				<CmtImage
					className={classes.logo}
					alt="InvestorMatch Logo"
					height="100px"
					src={(tenant.logo || {})["2x"]?.path || "/images/logo-v1.png"}
				/>
				<Box className={classes.authContent + " w-full mt-6"}>{children}</Box>
			</Box>
		</Box>
	);
};

export default AuthWrapper;
